import React from "react";
import { RefreshCw, ArrowRight } from "lucide-react";
import { MARK_DATA_URL } from "@/assets/mark";

export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[MinuteSwap] Render error:", error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.pathname !== this.props.pathname) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="relative flex min-h-screen items-center justify-center bg-[#08090A] px-5" data-testid="error-boundary">
        <div className="relative z-10 w-full max-w-md rounded-2xl border border-white/10 bg-[var(--surface)] p-8 text-center sm:p-10">
          <span className="mx-auto flex h-12 w-12 items-center justify-center">
            <img src={MARK_DATA_URL} alt="MinuteSwap" className="h-12 w-12 rounded-md" />
          </span>
          <h1 className="font-head mt-6 text-2xl font-black tracking-tight text-white sm:text-3xl">Something interrupted your Minute.</h1>
          <p className="mt-3 text-sm text-neutral-400">Nothing was lost. Try again, or head back to the Action Engine.</p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:justify-center">
            <button data-testid="error-retry-btn" onClick={() => window.location.reload()}
              className="btn-amber inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm">
              <RefreshCw className="h-4 w-4" /> Try again
            </button>
            <button data-testid="error-home-btn" onClick={() => { window.location.href = "/app"; }}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/15 px-6 py-3 text-sm text-white hover:bg-white/5">
              Action Engine <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}
